import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { error } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		boxSizing: 'border-box',
		flexDirection: 'column',
		padding: 8,
		gap: 20,

		'@media (min-width: 722px)': {
			padding: 40,
		},
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: 20,
		width: '100%',
	},
	buttonSubmit: {
		width: '100%',
		maxWidth: 350,
	},
	customFormSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		padding: 20,
	},
	formControl: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		alignItems: 'flex-start',
	},
	label: {
		fontSize: 14,
		fontWeight: 600,
		color: THEME.colors.text.main,
		marginBottom: 4,
	},
	selectBoxTriggerButton: {
		width: '100%',
		padding: 12,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		fontSize: 14,
		backgroundColor: THEME.colors.background.main,
		cursor: 'pointer',
		':focus': {
			outline: 'none',
			borderColor: THEME.colors.primary.main,
			boxShadow: '0 0 0 2px rgba(0, 123, 255, 0.25)',
		},
	},
	checkbox: {
		marginBottom: 8,
	},
	errorMessage: {
		color: error,
		fontSize: 12,
		marginTop: 4,
		marginBottom: 0,
	},
	required: {
		color: error,
		fontWeight: 'bold',
	},
});
